var _sodipodiNamedview, _defs, _metadata, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "60mm",
    height: "60mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5988.68 5988.68",
    id: "svg12",
    sodipodiDocname: "partner.svg",
    inkscapeVersion: "1.1.2 (76b9e6a115, 2022-02-25)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview14",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapePocument-units": "mm",
    showgrid: "false",
    inkscapeZoom: 4.3656249,
    inkscapeCx: 95.289909,
    inkscapeCy: 112.81317,
    "inkscapeWindow-width": 1320,
    "inkscapeWindow-height": 704,
    "inkscapeWindow-x": 46,
    "inkscapeWindow-y": 27,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g110"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1",
    inkscapeLabel: "Camada 1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 5988.68,
    height: 5988.68,
    id: "rect7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g11137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "matrix(1.2333487,0,0,1.2333487,-746.03758,-664.03638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect6264",
    style: {
      clipRule: "evenodd",
      fill: "#f5f5f5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 8.09271011,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 2300.8808,2934.1547 c 0,0 334.1356,434.3356 702.8636,432.6799 383.1127,-1.7204 686.7484,-472.9094 686.7484,-472.9094 839.962,-174.8352 1224.582,1270.4253 1099.0564,1847.8121 C 3674.5255,5649.877 2263.4937,5559.8449 1290.0776,4729.73 1105.4911,4261.9882 1627.7856,2646.955 2300.8808,2934.1547 Z",
    sodipodiNodetypes: "cscccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      clipRule: "evenodd",
      fill: "#ffdead",
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 4.8897,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 3693.8423,2706.5113 c -177.8176,252.6115 -418.9901,394.5272 -670.4622,394.5272 -251.4722,0 -492.6447,-141.9157 -670.4623,-394.5272 -177.8177,-252.6116 -277.7145,-595.2263 -277.7145,-952.473 22.8835,-535.5886 495.5432,-658.5785 980.6945,-668.9709 1053.6082,52.423 1125.1727,908.0837 637.9445,1621.4439 z",
    sodipodiNodetypes: "cssccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2230",
    style: {
      clipRule: "evenodd",
      fill: "#ffa500",
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 4.99056,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 2075.33,1134.0292 c 284.1902,-137.96461 156.3685,-448.26961 690.5585,-548.02413 816.1431,-152.40637 1112.7233,162.4451 1339.3155,595.26693 145.3337,277.607 71.6313,830.2092 -175.6761,923.4856 0,0 -164.4215,-540.1859 -629.8042,-635.0821 -373.0208,564.0821 -829.0664,362.8496 -910.0153,316.6541 C 2182.03,1804.66 2108.613,2043.883 2108.613,2043.883 1755.4427,1692.8402 1742.1968,1295.754 2075.33,1134.0292 Z",
    sodipodiNodetypes: "ssaccccs"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27882",
    style: {
      color: "#000000",
      clipRule: "nonzero",
      fill: "#9835d1",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 10.9792,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "auto"
    },
    d: "m 2089.859,2891.2819 c -136.7047,341.3028 -194.7512,725.4729 -172.422,1084.5157 -72.1465,36.7404 -119.2953,114.8035 -111.6973,199.7326 9.9492,111.2107 109.9261,194.7681 221.1366,184.819 111.2105,-9.9492 194.8194,-109.9307 184.8702,-221.1413 -7.7579,-86.7172 -70.5086,-155.9643 -150.3953,-177.8387 -6.5128,-357.9836 62.1974,-696.2103 168.5652,-1039.3129 -45.2733,-54.5927 -101.1795,-61.9444 -140.0574,-30.7744 z m -85.6181,1216.0515 c 28.5244,-2.5519 51.9627,17.0373 54.5146,45.5614 2.5518,28.5244 -17.0418,51.9113 -45.5661,54.4632 -28.5244,2.5519 -51.9068,-16.9903 -54.4586,-45.5148 -2.5519,-28.5241 16.9858,-51.958 45.5101,-54.5098 z",
    sodipodiNodetypes: "ccssscccsssss"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46230",
    style: {
      color: "#000000",
      clipRule: "nonzero",
      fill: "#9835d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 10.9792,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      shapeRendering: "auto"
    },
    d: "m 3843.8389,2825.1607 c -8.4884,1.0413 -16.7944,3.1212 -24.7064,6.1835 -50.0669,19.3541 -73.8994,73.0592 -53.2293,119.9489 48.0173,108.8692 95.7603,277.2782 80.6177,436.2217 -25.8498,4.5355 -88.6607,14.5759 -137.8704,72.8971 -56.6426,67.1302 -76.5923,160.3319 -82.062,333.1323 -2.7755,87.6831 -79.1701,267.9709 -111.1528,431.3907 -15.991,81.7101 -24.1505,166.8625 21.7149,246.7578 45.8651,79.8952 148.5893,125.6785 269.7577,127.3884 54.1719,0.7716 98.7485,-39.7442 99.5473,-90.4812 0.7949,-50.7177 -42.4555,-92.4376 -96.6072,-93.1861 -81.1013,-1.1451 -90.9765,-15.075 -99.9601,-30.724 -8.9834,-15.649 -14.2056,-61.9351 -1.5475,-126.6153 25.3169,-129.3604 109.2645,-301.656 114.2473,-459.0715 4.9917,-157.6961 33.4478,-217.056 39.9221,-224.7292 42.8455,-48.2808 105.9387,-50.3878 166.1359,-4.4442 6.4742,7.6732 34.9304,66.9847 39.9221,224.6807 5.082,160.5533 96.3455,334.1303 122.4484,462.8395 13.051,64.3546 6.8097,107.3737 -2.6823,121.8328 -9.4917,14.4594 -27.9824,32.3015 -122.0357,31.7383 -54.1499,-0.3141 -98.3227,40.5382 -98.6705,91.2541 -0.3354,50.716 43.2826,92.0874 97.4325,92.4134 130.3327,0.7791 237.6261,-38.9264 290.3378,-119.2245 52.712,-80.298 45.1154,-169.2279 28.2655,-252.3129 -33.6998,-166.1699 -116.3682,-349.4059 -119.0444,-433.9512 -5.4697,-172.8005 -25.4192,-266.0505 -82.062,-333.1806 -49.8195,-59.0441 -114.1647,-68.8298 -139.2115,-73.2351 14.274,-196.711 -42.8838,-380.7801 -96.1432,-501.5341 -16.9537,-38.4226 -59.3506,-61.3879 -103.3642,-55.9893 z",
    sodipodiNodetypes: "ccccsssscccsssccssscccssssccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.1a3592537897e852f86e2a8320aaaba7.svg";
export { ForwardRef as ReactComponent };